// import { linkSelector } from "../../extensions/link_selector/LinkSelector.js";
import { Plugins } from "./system/Plugins.js";
import { AjaxClick } from "./utils/AjaxClick.js";

export class Frontend {

    constructor() {

        console.log("[eventfive.wordpress-plugin]", "[Frontend]");

        new Plugins();        
        new AjaxClick();

        // setTimeout(() => {
        //     linkSelector.open({
        //         onSelect: (link) => {
        //             console.log(link);
        //         }
        //     });
        // }, 100);
    }
}

e5.ready(() => {
    new Frontend();
});